import { default as events60BEbBhlAjMeta } from "/vercel/path0/pages/apps/[id]/[connectionId]/events.vue?macro=true";
import { default as indexZLD1dTZ2hxMeta } from "/vercel/path0/pages/apps/[id]/[connectionId]/index.vue?macro=true";
import { default as runs8JkU5grZZ0Meta } from "/vercel/path0/pages/apps/[id]/[connectionId]/runs.vue?macro=true";
import { default as tasksclsvkFusiLMeta } from "/vercel/path0/pages/apps/[id]/[connectionId]/tasks.vue?macro=true";
import { default as editM3QGyhj9OjMeta } from "/vercel/path0/pages/apps/[id]/edit.vue?macro=true";
import { default as indextX3aDn9zGUMeta } from "/vercel/path0/pages/apps/[id]/index.vue?macro=true";
import { default as indexVSdB0PktgUMeta } from "/vercel/path0/pages/apps/afas_old/index.vue?macro=true";
import { default as editoTwyZY636YMeta } from "/vercel/path0/pages/apps/salesforce/[id]/edit.vue?macro=true";
import { default as _91channel_93gAZZvqjEY4Meta } from "/vercel/path0/pages/apps/whatsapp/[connection]/channels/[channel].vue?macro=true";
import { default as finalizefFriFRgVcqMeta } from "/vercel/path0/pages/auth/finalize.vue?macro=true";
import { default as googlec92m0B0Gd6Meta } from "/vercel/path0/pages/auth/google.vue?macro=true";
import { default as _91token_933Ptn3HHyRDMeta } from "/vercel/path0/pages/auth/invitation/[token].vue?macro=true";
import { default as loginILQdBdZzRsMeta } from "/vercel/path0/pages/auth/login.vue?macro=true";
import { default as password_45reset1WIJaoCAKRMeta } from "/vercel/path0/pages/auth/password-reset.vue?macro=true";
import { default as registerUZDCsj62s6Meta } from "/vercel/path0/pages/auth/register.vue?macro=true";
import { default as editixPbl5fk6pMeta } from "/vercel/path0/pages/automations/[id]/edit.vue?macro=true";
import { default as events1X90ZLeINBMeta } from "/vercel/path0/pages/automations/[id]/events.vue?macro=true";
import { default as indexLP97fYYB4jMeta } from "/vercel/path0/pages/automations/[id]/index.vue?macro=true";
import { default as runs14PL5lFDkLMeta } from "/vercel/path0/pages/automations/[id]/runs.vue?macro=true";
import { default as tasksDEXYIlGXBbMeta } from "/vercel/path0/pages/automations/[id]/tasks.vue?macro=true";
import { default as workflowTcJK1XOuOUMeta } from "/vercel/path0/pages/automations/[id]/workflow.vue?macro=true";
import { default as indexleglyDI3FkMeta } from "/vercel/path0/pages/automations/index.vue?macro=true";
import { default as indexbqe5w8Ir0rMeta } from "/vercel/path0/pages/emails/[id]/index.vue?macro=true";
import { default as previewexHD0fJwtVMeta } from "/vercel/path0/pages/emails/[id]/preview.vue?macro=true";
import { default as indexXMT3Q2chMrMeta } from "/vercel/path0/pages/emails/index.vue?macro=true";
import { default as automationsCMWYuXx8epMeta } from "/vercel/path0/pages/embed/carerix/automations.vue?macro=true";
import { default as inboxFF9mRvC3RTMeta } from "/vercel/path0/pages/embed/carerix/inbox.vue?macro=true";
import { default as settingspAXd1bAJMPMeta } from "/vercel/path0/pages/embed/carerix/settings.vue?macro=true";
import { default as tasksnC5cH6Xu9BMeta } from "/vercel/path0/pages/embed/carerix/tasks.vue?macro=true";
import { default as whatsappmWtI4FR597Meta } from "/vercel/path0/pages/embed/carerix/whatsapp.vue?macro=true";
import { default as _91id_93SPaHek1mR9Meta } from "/vercel/path0/pages/forms/[id].vue?macro=true";
import { default as indexxilcPU8IE3Meta } from "/vercel/path0/pages/forms/index.vue?macro=true";
import { default as _91_91roomId_93_93EuamKL93KNMeta } from "/vercel/path0/pages/inbox/[[roomId]].vue?macro=true";
import { default as _91_91roomId_93_93I31rA8TcanMeta } from "/vercel/path0/pages/inbox/email/[[roomId]].vue?macro=true";
import { default as _91id_93OCqkPaKG8zMeta } from "/vercel/path0/pages/inbox/responses/[id].vue?macro=true";
import { default as indexbj5eOJQBwMMeta } from "/vercel/path0/pages/inbox/responses/index.vue?macro=true";
import { default as _91_91roomId_93_93LAC7R31dCcMeta } from "/vercel/path0/pages/inbox/whatsapp/[[roomId]].vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as _91id_93sw4dmuYVKKMeta } from "/vercel/path0/pages/people/[id].vue?macro=true";
import { default as index3McTQJxm2fMeta } from "/vercel/path0/pages/people/index.vue?macro=true";
import { default as _91token_9317MjRCSdogMeta } from "/vercel/path0/pages/public/domains/dns/[token].vue?macro=true";
import { default as _91_46_46_46id_931Vp7BmwHh1Meta } from "/vercel/path0/pages/public/forms/[...id].vue?macro=true";
import { default as _91token_93FhSTBuJVT9Meta } from "/vercel/path0/pages/public/notifications/unsubscribe/[token].vue?macro=true";
import { default as billingvRkqVCf8RrMeta } from "/vercel/path0/pages/settings/account/billing.vue?macro=true";
import { default as block_45listRfPuDXPBZ0Meta } from "/vercel/path0/pages/settings/account/block-list.vue?macro=true";
import { default as _91id_93vouzo2BjxCMeta } from "/vercel/path0/pages/settings/account/brands/[id].vue?macro=true";
import { default as index4gtHbHBb5pMeta } from "/vercel/path0/pages/settings/account/brands/index.vue?macro=true";
import { default as _91id_93fc5prLBOs6Meta } from "/vercel/path0/pages/settings/account/domains/[id].vue?macro=true";
import { default as indexGodYLNlHkNMeta } from "/vercel/path0/pages/settings/account/domains/index.vue?macro=true";
import { default as indexw1wl5WheGNMeta } from "/vercel/path0/pages/settings/account/index.vue?macro=true";
import { default as localizationFhiihJS75bMeta } from "/vercel/path0/pages/settings/account/localization.vue?macro=true";
import { default as _91id_93O8FqbgZ1DSMeta } from "/vercel/path0/pages/settings/account/locations/[id].vue?macro=true";
import { default as index2llE7v4AByMeta } from "/vercel/path0/pages/settings/account/locations/index.vue?macro=true";
import { default as safety_45limitshsKBtlrpezMeta } from "/vercel/path0/pages/settings/account/safety-limits.vue?macro=true";
import { default as unsubscribesnFAxVji1p0Meta } from "/vercel/path0/pages/settings/account/unsubscribes.vue?macro=true";
import { default as usage0JdS1flgPfMeta } from "/vercel/path0/pages/settings/account/usage.vue?macro=true";
import { default as _91id_937IkjeRjxwyMeta } from "/vercel/path0/pages/settings/account/users/[id].vue?macro=true";
import { default as indexFEZwAL89kVMeta } from "/vercel/path0/pages/settings/account/users/index.vue?macro=true";
import { default as indexXkn6owxyykMeta } from "/vercel/path0/pages/settings/apps/index.vue?macro=true";
import { default as _91id_932s0xr292EcMeta } from "/vercel/path0/pages/settings/events/[id].vue?macro=true";
import { default as indexJncxwH3kmBMeta } from "/vercel/path0/pages/settings/events/index.vue?macro=true";
import { default as profilenpRL1NO0W5Meta } from "/vercel/path0/pages/settings/me/profile.vue?macro=true";
import { default as _91id_93AElMsj73dTMeta } from "/vercel/path0/pages/settings/runs/[id].vue?macro=true";
import { default as indexI2eFbFsPzpMeta } from "/vercel/path0/pages/settings/runs/index.vue?macro=true";
import { default as _91id_93VGA3lDrMp6Meta } from "/vercel/path0/pages/tasks/[id].vue?macro=true";
import { default as indexJXtAVaJahmMeta } from "/vercel/path0/pages/tasks/index.vue?macro=true";
import { default as component_45stubCmayfDKtxAMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@22.9.0_eslint@9.15.0_jiti@2.4.0__ioredis@5.4._md7ulalvrrinrnf4sawffzfdna/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubCmayfDKtxA } from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@22.9.0_eslint@9.15.0_jiti@2.4.0__ioredis@5.4._md7ulalvrrinrnf4sawffzfdna/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "apps-id-connectionId-events",
    path: "/apps/:id()/:connectionId()/events",
    component: () => import("/vercel/path0/pages/apps/[id]/[connectionId]/events.vue")
  },
  {
    name: "apps-id-connectionId",
    path: "/apps/:id()/:connectionId()",
    component: () => import("/vercel/path0/pages/apps/[id]/[connectionId]/index.vue")
  },
  {
    name: "apps-id-connectionId-runs",
    path: "/apps/:id()/:connectionId()/runs",
    component: () => import("/vercel/path0/pages/apps/[id]/[connectionId]/runs.vue")
  },
  {
    name: "apps-id-connectionId-tasks",
    path: "/apps/:id()/:connectionId()/tasks",
    component: () => import("/vercel/path0/pages/apps/[id]/[connectionId]/tasks.vue")
  },
  {
    name: "apps-id-edit",
    path: "/apps/:id()/edit",
    component: () => import("/vercel/path0/pages/apps/[id]/edit.vue")
  },
  {
    name: "apps-id",
    path: "/apps/:id()",
    component: () => import("/vercel/path0/pages/apps/[id]/index.vue")
  },
  {
    name: "apps-afas_old",
    path: "/apps/afas_old",
    component: () => import("/vercel/path0/pages/apps/afas_old/index.vue")
  },
  {
    name: "apps-salesforce-id-edit",
    path: "/apps/salesforce/:id()/edit",
    component: () => import("/vercel/path0/pages/apps/salesforce/[id]/edit.vue")
  },
  {
    name: "apps-whatsapp-connection-channels-channel",
    path: "/apps/whatsapp/:connection()/channels/:channel()",
    component: () => import("/vercel/path0/pages/apps/whatsapp/[connection]/channels/[channel].vue")
  },
  {
    name: "auth-finalize",
    path: "/auth/finalize",
    meta: finalizefFriFRgVcqMeta || {},
    component: () => import("/vercel/path0/pages/auth/finalize.vue")
  },
  {
    name: "auth-google",
    path: "/auth/google",
    meta: googlec92m0B0Gd6Meta || {},
    component: () => import("/vercel/path0/pages/auth/google.vue")
  },
  {
    name: "auth-invitation-token",
    path: "/invitation/:token",
    meta: _91token_933Ptn3HHyRDMeta || {},
    component: () => import("/vercel/path0/pages/auth/invitation/[token].vue")
  },
  {
    name: "auth-login",
    path: "/login",
    meta: loginILQdBdZzRsMeta || {},
    component: () => import("/vercel/path0/pages/auth/login.vue")
  },
  {
    name: "auth-password-reset",
    path: "/password/reset",
    meta: password_45reset1WIJaoCAKRMeta || {},
    component: () => import("/vercel/path0/pages/auth/password-reset.vue")
  },
  {
    name: "auth-register",
    path: "/register",
    meta: registerUZDCsj62s6Meta || {},
    component: () => import("/vercel/path0/pages/auth/register.vue")
  },
  {
    name: "automations-id-edit",
    path: "/automations/:id()/edit",
    component: () => import("/vercel/path0/pages/automations/[id]/edit.vue")
  },
  {
    name: "automations-id-events",
    path: "/automations/:id()/events",
    component: () => import("/vercel/path0/pages/automations/[id]/events.vue")
  },
  {
    name: "automations-id",
    path: "/automations/:id()",
    component: () => import("/vercel/path0/pages/automations/[id]/index.vue")
  },
  {
    name: "automations-id-runs",
    path: "/automations/:id()/runs",
    component: () => import("/vercel/path0/pages/automations/[id]/runs.vue")
  },
  {
    name: "automations-id-tasks",
    path: "/automations/:id()/tasks",
    component: () => import("/vercel/path0/pages/automations/[id]/tasks.vue")
  },
  {
    name: "automations-id-workflow",
    path: "/automations/:id()/workflow",
    meta: workflowTcJK1XOuOUMeta || {},
    component: () => import("/vercel/path0/pages/automations/[id]/workflow.vue")
  },
  {
    name: "automations",
    path: "/automations",
    component: () => import("/vercel/path0/pages/automations/index.vue")
  },
  {
    name: "emails-id",
    path: "/emails/:id()",
    component: () => import("/vercel/path0/pages/emails/[id]/index.vue")
  },
  {
    name: "emails-id-preview",
    path: "/emails/:id()/preview",
    component: () => import("/vercel/path0/pages/emails/[id]/preview.vue")
  },
  {
    name: "emails",
    path: "/emails",
    component: () => import("/vercel/path0/pages/emails/index.vue")
  },
  {
    name: "embed-carerix-automations",
    path: "/embed/carerix/automations",
    meta: automationsCMWYuXx8epMeta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/automations.vue")
  },
  {
    name: "embed-carerix-inbox",
    path: "/embed/carerix/inbox",
    meta: inboxFF9mRvC3RTMeta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/inbox.vue")
  },
  {
    name: "embed-carerix-settings",
    path: "/embed/carerix/settings",
    meta: settingspAXd1bAJMPMeta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/settings.vue")
  },
  {
    name: "embed-carerix-tasks",
    path: "/embed/carerix/tasks",
    meta: tasksnC5cH6Xu9BMeta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/tasks.vue")
  },
  {
    name: "embed-carerix-whatsapp",
    path: "/embed/carerix/whatsapp",
    meta: whatsappmWtI4FR597Meta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/whatsapp.vue")
  },
  {
    name: "forms-id",
    path: "/forms/:id()",
    component: () => import("/vercel/path0/pages/forms/[id].vue")
  },
  {
    name: "forms",
    path: "/forms",
    component: () => import("/vercel/path0/pages/forms/index.vue")
  },
  {
    name: "inbox-roomId",
    path: "/inbox/:roomId?",
    meta: _91_91roomId_93_93EuamKL93KNMeta || {},
    component: () => import("/vercel/path0/pages/inbox/[[roomId]].vue")
  },
  {
    name: "inbox-email-roomId",
    path: "/inbox/email/:roomId?",
    component: () => import("/vercel/path0/pages/inbox/email/[[roomId]].vue")
  },
  {
    name: "inbox-responses-id",
    path: "/inbox/responses/:id()",
    component: () => import("/vercel/path0/pages/inbox/responses/[id].vue")
  },
  {
    name: "inbox-responses",
    path: "/inbox/responses",
    component: () => import("/vercel/path0/pages/inbox/responses/index.vue")
  },
  {
    name: "inbox-whatsapp-roomId",
    path: "/inbox/whatsapp/:roomId?",
    component: () => import("/vercel/path0/pages/inbox/whatsapp/[[roomId]].vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "people-id",
    path: "/people/:id()",
    component: () => import("/vercel/path0/pages/people/[id].vue")
  },
  {
    name: "people",
    path: "/people",
    component: () => import("/vercel/path0/pages/people/index.vue")
  },
  {
    name: "public-domains-dns-token",
    path: "/public/domains/dns/:token()",
    meta: _91token_9317MjRCSdogMeta || {},
    component: () => import("/vercel/path0/pages/public/domains/dns/[token].vue")
  },
  {
    name: "public-forms-id",
    path: "/public/forms/:id(.*)*",
    meta: _91_46_46_46id_931Vp7BmwHh1Meta || {},
    component: () => import("/vercel/path0/pages/public/forms/[...id].vue")
  },
  {
    name: "public-notifications-unsubscribe-token",
    path: "/public/notifications/unsubscribe/:token()",
    meta: _91token_93FhSTBuJVT9Meta || {},
    component: () => import("/vercel/path0/pages/public/notifications/unsubscribe/[token].vue")
  },
  {
    name: "settings-account-billing",
    path: "/settings/account/billing",
    component: () => import("/vercel/path0/pages/settings/account/billing.vue")
  },
  {
    name: "settings-account-block-list",
    path: "/settings/account/block-list",
    component: () => import("/vercel/path0/pages/settings/account/block-list.vue")
  },
  {
    name: "settings-account-brands-id",
    path: "/settings/account/brands/:id()",
    component: () => import("/vercel/path0/pages/settings/account/brands/[id].vue")
  },
  {
    name: "settings-account-brands",
    path: "/settings/account/brands",
    component: () => import("/vercel/path0/pages/settings/account/brands/index.vue")
  },
  {
    name: "settings-account-domains-id",
    path: "/settings/account/domains/:id()",
    component: () => import("/vercel/path0/pages/settings/account/domains/[id].vue")
  },
  {
    name: "settings-account-domains",
    path: "/settings/account/domains",
    component: () => import("/vercel/path0/pages/settings/account/domains/index.vue")
  },
  {
    name: "settings-account",
    path: "/settings/account",
    component: () => import("/vercel/path0/pages/settings/account/index.vue")
  },
  {
    name: "settings-account-localization",
    path: "/settings/account/localization",
    component: () => import("/vercel/path0/pages/settings/account/localization.vue")
  },
  {
    name: "settings-account-locations-id",
    path: "/settings/account/locations/:id()",
    component: () => import("/vercel/path0/pages/settings/account/locations/[id].vue")
  },
  {
    name: "settings-account-locations",
    path: "/settings/account/locations",
    component: () => import("/vercel/path0/pages/settings/account/locations/index.vue")
  },
  {
    name: "settings-account-safety-limits",
    path: "/settings/account/safety-limits",
    component: () => import("/vercel/path0/pages/settings/account/safety-limits.vue")
  },
  {
    name: "settings-account-unsubscribes",
    path: "/settings/account/unsubscribes",
    component: () => import("/vercel/path0/pages/settings/account/unsubscribes.vue")
  },
  {
    name: "settings-account-usage",
    path: "/settings/account/usage",
    component: () => import("/vercel/path0/pages/settings/account/usage.vue")
  },
  {
    name: "settings-account-users-id",
    path: "/settings/account/users/:id()",
    component: () => import("/vercel/path0/pages/settings/account/users/[id].vue")
  },
  {
    name: "settings-account-users",
    path: "/settings/account/users",
    component: () => import("/vercel/path0/pages/settings/account/users/index.vue")
  },
  {
    name: "settings-apps",
    path: "/settings/apps",
    component: () => import("/vercel/path0/pages/settings/apps/index.vue")
  },
  {
    name: "settings-events-id",
    path: "/settings/events/:id()",
    component: () => import("/vercel/path0/pages/settings/events/[id].vue")
  },
  {
    name: "settings-events",
    path: "/settings/events",
    component: () => import("/vercel/path0/pages/settings/events/index.vue")
  },
  {
    name: "settings-me-profile",
    path: "/settings/me/profile",
    component: () => import("/vercel/path0/pages/settings/me/profile.vue")
  },
  {
    name: "settings-runs-id",
    path: "/settings/runs/:id()",
    component: () => import("/vercel/path0/pages/settings/runs/[id].vue")
  },
  {
    name: "settings-runs",
    path: "/settings/runs",
    component: () => import("/vercel/path0/pages/settings/runs/index.vue")
  },
  {
    name: "tasks-id",
    path: "/tasks/:id()",
    component: () => import("/vercel/path0/pages/tasks/[id].vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    component: () => import("/vercel/path0/pages/tasks/index.vue")
  },
  {
    name: component_45stubCmayfDKtxAMeta?.name,
    path: "/auth/login",
    component: component_45stubCmayfDKtxA
  },
  {
    name: component_45stubCmayfDKtxAMeta?.name,
    path: "/auth/register",
    component: component_45stubCmayfDKtxA
  },
  {
    name: component_45stubCmayfDKtxAMeta?.name,
    path: "/auth/invitation/:pathMatch(.*)",
    component: component_45stubCmayfDKtxA
  },
  {
    name: component_45stubCmayfDKtxAMeta?.name,
    path: "/auth/password-reset",
    component: component_45stubCmayfDKtxA
  }
]